<template>
  <b-modal :id="modalId" title="Contact Details" hide-footer>

    <div class="row">
      <div class="col-md-6">
        <div class="form-group mb-3">
          <b>First Name</b><br>
          {{ contact.first_name ? contact.first_name : '-' }}
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group mb-3">
          <b>Last Name</b><br>
          {{ contact.last_name ? contact.last_name : '-' }}
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="form-group mb-3">
          <b>Email</b><br>
          {{ contact.email ? contact.email : '-' }}
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group mb-3">
          <b>Phone</b><br>
          {{ contact.phone_number ? contact.phone_number : '-' }}
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="form-group mb-3">
          <b>Fax</b><br>
          {{ contact.fax ? contact.fax : '-' }}
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group mb-3">
          <b>Emergency Phone</b><br>
          {{ contact.emergency_phone_number ? contact.emergency_phone_number : '-' }}
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <b>Notes</b><br>
          {{ contact.notes ? contact.notes : '-' }}
        </div>
      </div>
    </div>

  </b-modal>
</template>

<script>
export default {
  name: "ViewContactModal",
  props: ['contact'],
  data() {
    return {
      isSaving: false,
      serverErrors: []
    }
  },
  mixins: [],
  computed: {
    modalId() {
      return 'view-contact-' + this.contact.id + '-modal';
    }
  }
}
</script>

<style scoped>

</style>
